import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementPendingApproval } from "./selectorIsRequirementPendingApproval";

export const selectorIsRequirementPostApproval = (
  requirement: PayeeRequirement
) => {
  const isNotWaitingForApprovalNow =
    !selectorIsRequirementPendingApproval(requirement);

  const isStatusAlreadyOverridden = !!requirement.payerOverrideStatus;

  return isNotWaitingForApprovalNow && isStatusAlreadyOverridden;
};
